import React, { useEffect, useState, useCallback } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DonationSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("checking");
    const [data, setData] = useState(null);

    const poll = useCallback(
        async (attempts = 0) => {
            if (attempts >= 10) {
                setStatus("timeout");
                return;
            }
            try {
                const res = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
                setData(res.data);
                if (res.data.payment_status === "paid") {
                    setStatus("paid");
                    return;
                }
                if (res.data.status === "expired") {
                    setStatus("expired");
                    return;
                }
                setTimeout(() => poll(attempts + 1), 2000);
            } catch (e) {
                setStatus("error");
            }
        },
        [sessionId]
    );

    useEffect(() => {
        if (sessionId) poll(0);
        else setStatus("error");
    }, [sessionId, poll]);

    return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center px-6">
            <div className="max-w-xl w-full border border-white/10 bg-inksurface p-10 text-center" data-testid="donation-success-page">
                {status === "checking" && (
                    <>
                        <Loader2 className="mx-auto animate-spin text-volt" size={40} />
                        <h1 className="font-display font-black uppercase text-3xl mt-6">Verifying your gift…</h1>
                        <p className="text-zinc-400 mt-3">Please hold on, this only takes a moment.</p>
                    </>
                )}
                {status === "paid" && (
                    <>
                        <CheckCircle2 className="mx-auto text-volt" size={50} />
                        <h1 className="font-display font-black uppercase text-4xl mt-6">Thank you.</h1>
                        <p className="text-zinc-300 mt-4 text-lg">
                            Your gift of €{data?.amount_total ? (data.amount_total / 100).toFixed(2) : "—"} powers the next Urban Rookie.
                        </p>
                        <Link to="/" data-testid="back-home" className="btn-volt inline-block mt-8 px-8 py-4 text-xs">
                            ← Back home
                        </Link>
                    </>
                )}
                {(status === "expired" || status === "timeout" || status === "error") && (
                    <>
                        <XCircle className="mx-auto text-red-400" size={50} />
                        <h1 className="font-display font-black uppercase text-3xl mt-6">Something went sideways</h1>
                        <p className="text-zinc-400 mt-4">
                            We couldn't confirm your payment. If you completed it, please reach out via the contact form.
                        </p>
                        <Link to="/" className="btn-ghost inline-block mt-8 px-8 py-4 text-xs uppercase font-bold tracking-wider">
                            ← Back home
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
